export const previewInfo = state => state.previewInfo
